(function(utils) {
	utils.izracunajPorez = izracunajPorez;
	utils.izracunajPorezOdIznosa = izracunajPorezOdIznosa;
	utils.predloziIznosePoreza = predloziIznosePoreza;

	utils.ispisRUgovorSSaldo = ispisRUgovorSSaldo;
	utils.ispisRuZahtjevSaldo = ispisRuZahtjevSaldo;
	utils.ispisRUgovorSaldoPo = ispisRUgovorSaldoPo;
	utils.dajDugPot = dajDugPot;
	utils.dajDugPotK = dajDugPotK;
	
	utils.rowAddPNabaveS = rowAddPNabaveS;
	utils.rowAddPNabaveSDetaljni = rowAddPNabaveSDetaljni;
	utils.rowAddRiznica = rowAddRiznica;
	utils.rowAddProtu = rowAddProtu;
	
	utils.KreirajPregledUgovorenoZaPNabaveS = KreirajPregledUgovorenoZaPNabaveS;
	utils.ispisSaldoDok = ispisSaldoDok;
	utils.izrSaldoKnjigaPregled = izrSaldoKnjigaPregled;
	utils.ispisKnjigaRuDok = ispisKnjigaRuDok;	
	utils.SaldoMTroskaKartica = SaldoMTroskaKartica;
	utils.filterPanelKnjiziDok = filterPanelKnjiziDok;
	utils.filterPanelKnjiziDokSakrij = filterPanelKnjiziDokSakrij;
	utils.filterPanelKnjiziDokBtnActive = filterPanelKnjiziDokBtnActive;
	utils.filterPanelOdrediTablicu = filterPanelOdrediTablicu;

	utils.dajPredlozenoIzInfo = dajPredlozenoIzInfo;	

	utils.izrSaldoKnjigaFilter = izrSaldoKnjigaFilter;

	function dajDugPotK (lfDug, lfPot, lfDugS, lfPotS, lbPrvaProtu) {
	        if (!lfDug) lfDug = 0;
	        if (!lfPot) lfPot = 0;
	        if (!lfDugS) lfDugS = 0;
	        if (!lfPotS) lfPotS = 0;
		
		    if (lfPot != 0) 
		        return 'P'
		    else if (lfDug != 0)
		        return 'D'
		    else if (lbPrvaProtu && (lfPotS != 0))
		        return 'P'
		    else if (lbPrvaProtu && (lfDugS != 0))
		        return 'D'
		    else if (!lbPrvaProtu && (lfPotS != 0))
		        return 'D'
		    else if (!lbPrvaProtu && (lfDugS != 0))
		        return 'P'
			}
	
	function dajDugPot (lfDug, lfPot, lsOpcije, lbOtvara) {
	        if (!lfDug) lfDug = 0;
	        if (!lfPot) lfPot = 0;
		
		    if (lfPot != 0) 
		        return 'P'
		    else if (lfDug != 0)
		        return 'D'
		    // Ako je (dobavljač i otvara) ili ako je (kupac i zatvara)
		    else if (((lsOpcije.indexOf('D') > -1) && lbOtvara) || ((lsOpcije.indexOf('K') > -1) && !lbOtvara))
		        return 'P'
		    // Ako je (kupac i otvara) ili ako je (dobavljač i zatvara)
		    else if (((lsOpcije.indexOf('K') > -1) && lbOtvara) || ((lsOpcije.indexOf('D') > -1) && lbOtvara))
		        return 'D';
			}

   function izracunajPorez(lfIznosPoreza, lfStopa, lfPostoNep) {
	    var lfPor = 0;
	    var lfPorNe = 0;
	    var lfIsp = 0;
	    var lfIspNe = 0;
	    
	    if (lfIznosPoreza != 0) {
	        lfPor = lfIznosPoreza;
	        lfIsp = KUtils.parseFloat(lfIznosPoreza / (lfStopa / 100));
	    }

	    if ((lfIznosPoreza != 0) && (lfPostoNep != 0)) {
	        lfPorNe = KUtils.parseFloat(lfPor * (lfPostoNep / 100));
	       	lfPorNe = KUtils.toFixed(lfPorNe, 2); 
	        lfPor = KUtils.parseFloat(lfPor - lfPorNe);
	
	        lfIspNe = KUtils.parseFloat(lfIsp * (lfPostoNep / 100));
	       	lfIspNe = KUtils.toFixed(lfIspNe, 2); 
	        lfIsp = KUtils.parseFloat(lfIsp - lfIspNe);
	    }
   		
        return [lfIsp, lfPor];
        }
	
   function izracunajPorezOdIznosa(lfUkIznos, lfStopa) {
	    var lfPor = 0;
	    lfPor = KUtils.parseFloat(lfUkIznos / ((lfStopa / 100) + 1));
	    lfPor = KUtils.toFixed(lfPor, 2); 
	    lfPor = KUtils.parseFloat(lfUkIznos - lfPor);
	    lfIsp = lfUkIznos - lfPor;
	    return [lfIsp, lfPor];
        }
	
	
	function predloziIznosePoreza(lfSkIznos, lfIzn25, lfIzn13, lfIzn5, lfIznNeoporezivo, lfZaStopu) {
        if (!lfSkIznos) lfSkIznos = 0;
        if (!lfIzn25) lfIzn25 = 0;
        if (!lfIzn13) lfIzn13 = 0;
        if (!lfIzn5) lfIzn5 = 0;
        if (!lfIznNeoporezivo) lfIznNeoporezivo = 0;
        lfIsp = lfSkIznos;

        if (KUtils.parseFloat(lfSkIznos) != 0) {
	        if (lfZaStopu == 25) {
	            laRez = konto.gs.utils.izracunajPorezOdIznosa(lfSkIznos, 25);
	            lfSkIznos = lfSkIznos - (laRez[0] + laRez[1]);
	            lfIzn25 = KUtils.parseFloat(laRez[1]);
	        }
	        else if (KUtils.parseFloat(lfIzn25) != 0) {
	            laRez = konto.gs.utils.izracunajPorez(lfIzn25, 25, 0); // ne zanima me nepriznato
	            lfSkIznos = lfSkIznos - (laRez[0] + laRez[1]);
	            lfIzn25 = KUtils.parseFloat(laRez[1]);
	       	}
	  	}

        if (KUtils.parseFloat(lfSkIznos) != 0) {
	        if (lfZaStopu == 13) {
	            laRez = konto.gs.utils.izracunajPorezOdIznosa(lfSkIznos, 13);
	            lfSkIznos = lfSkIznos - (laRez[0] + laRez[1]);
	            lfIzn13 = KUtils.parseFloat(laRez[1]);
	        }
	        else if (KUtils.parseFloat(lfIzn13) != 0) {
	            laRez = konto.gs.utils.izracunajPorez(lfIzn13, 13, 0); // ne zanima me nepriznato
	            lfSkIznos = lfSkIznos - (laRez[0] + laRez[1]);
	            lfIzn13 = KUtils.parseFloat(laRez[1]);
	       	}
	  	}

        if (KUtils.parseFloat(lfSkIznos) != 0) {
	        if (lfZaStopu == 5) {
	            laRez = konto.gs.utils.izracunajPorezOdIznosa(lfSkIznos, 5);
	            lfSkIznos = lfSkIznos - (laRez[0] + laRez[1]);
	            lfIzn5 = KUtils.parseFloat(laRez[1]);
	        }
	        else if (KUtils.parseFloat(lfIzn5) != 0) {
	            laRez = konto.gs.utils.izracunajPorez(lfIzn5, 5, 0); // ne zanima me nepriznato
	            lfSkIznos = lfSkIznos - (laRez[0] + laRez[1]);
	            lfIzn5 = KUtils.parseFloat(laRez[1]);
	       	}
	  	}

        if ((KUtils.parseFloat(lfSkIznos) != 0) || (lfZaStopu == 0) ) {
            lfIznNeoporezivo = KUtils.parseFloat(lfSkIznos);
            lfIznNeoporezivo = KUtils.toFixed(lfIznNeoporezivo, 2); 
        }

        return [lfIzn25, lfIzn13, lfIzn5, lfIznNeoporezivo];
    }	
    
	function ispisRUgovorSSaldo(ind, data, round) {
				var SaldoPrih = data.FPrihvatljivoIznos - data.FZnsPrihvatljivoIznos;
				var Saldo = data.FIznos - data.FZnsIznos;
	            var table = $("<table class='k-grid' border=0 style='margin: 0px;' width='100%';>");
	            var lsStavka = '';
	            var lsUdio = '';
	            if (ind == 'ru') {
	                lsStavka = 'Stavka ug. ' + data.FStavka + ' (' + data.FRUgovor + '-' + data.FRUgovorS + ') ' + data.FOpisStavke + 
	                    ', Iznos projekta: ' + KUtils.formatFloat(data.FProjektIznos);
	                table.append(
	                    "<tr style='font-weight:bold;'>" + 
	                        " <td class='col-md-12' colspan=12>" + lsStavka + "</td> " +
	                    "</tr>");
	                var d = " <tr>" +
	                        " <td class='col-md-8' colspan=8 style='font-weight:bold;'> Prihvatljivo | Iznos (" + KUtils.formatFloat(data.FUdioPosto, round) + "%)</td> " +                                       
	                        " <td class='col-md-2 text-right'> " + KUtils.formatFloat(data.FPrihvatljivoIznos) + " </td> " +                                       
	                        " <td class='col-md-2 text-right'> " + KUtils.formatFloat(data.FIznos) + " </td>" +
	                    "</tr> ";
	                table.append(d);
	                var d = " <tr>" +
	                        " <td class='col-md-8' colspan=8 style='font-weight:bold;'> Ukupno ZNS-ovi</td> " + 
	                        " <td class='col-md-2 text-right'> " + KUtils.formatFloat(data.FZnsPrihvatljivoIznos)  + " </td>" + 
	                        " <td class='col-md-2 text-right'> " + KUtils.formatFloat(data.FZnsIznos)  + " </td>" + 
	                    "</tr> ";
	                table.append(d);
	                
	                if (data.FZnsIznosKor || data.FZnsPrihvatljivoIznosKor) {
		                var d = " <tr>" +
		                        " <td class='col-md-8' colspan=8 style='font-weight:bold;'> Ukupno KOR</td> " + 
		                        " <td class='col-md-2 text-right'> " + KUtils.formatFloat(data.FZnsPrihvatljivoIznosKor)  + " </td>" + 
		                        " <td class='col-md-2 text-right'> " + KUtils.formatFloat(data.FZnsIznosKor)  + " </td>" + 
		                    "</tr> ";
		                table.append(d);
		                
						if (data.FZnsPrihvatljivoIznosKor) {
							SaldoPrih = SaldoPrih - data.FZnsPrihvatljivoIznosKor;
						}
						if (data.FZnsIznosKor) {
							Saldo = Saldo - data.FZnsIznosKor;
							}
	                }

					if (KUtils.parseFloat(Saldo) <= 0) {
						var lsClass = "alert-danger";
						}	
					else {
						var lsClass = "";
						}	


	                var d = " <tr>" +
	                        " <td class='col-md-8' colspan=8 style='font-weight:bold;'> Saldo </td> " + 
	                        " <td class='col-md-2 text-right " + lsClass + "'> " + KUtils.formatFloat(SaldoPrih)  + " </td>" + 
	                        " <td class='col-md-2 text-right " + lsClass + "'> " + KUtils.formatFloat(Saldo)  + " </td>" + 
	                    "</tr> ";
	                table.append(d);
	                }

	                //if (data.FZnsKategorijaIznos || data.FZnsKategorijaPrihvatljivoIznos) {
	                	var lsTitle = "Na ukupan prihvatljiv iznos (svi ZNS-ovi tog ugovora za kategoriju iz stavke ugovora) primijenjuje se udio. Razlika = Izračunati iznos - suma iznosa po ZNS-ovima";
	                	var Izracunato = KUtils.formatFloat(KUtils.parseFloat(data.FZnsKategorijaPrihvatljivoIznos*data.FUdioPosto/100 ), 2);
						var Razlika = KUtils.parseFloat(Izracunato) - KUtils.parseFloat(data.FZnsKategorijaIznos);
						if (KUtils.formatFloat(Razlika) == '0,00') {
							var lsClass = "";
							}	
						else {
							var lsClass = "class='alert-danger'";
							}	
						var Opis = "Kategorija (ug.): | " + 
							KUtils.formatFloat(data.FZnsKategorijaPrihvatljivoIznos) + ' | ' + KUtils.formatFloat(data.FZnsKategorijaIznos) +
							' | ' + KUtils.formatFloat(data.FZnsKategorijaPrihvatljivoIznos) + ' * ' + KUtils.formatFloat(data.FUdioPosto,round) + ' = ' +
							KUtils.formatFloat((data.FZnsKategorijaPrihvatljivoIznos*data.FUdioPosto)/100 ) +
							' | RAZLIKA -> ';
		                var d = " <tr " + lsClass +" title='" + lsTitle + "'>" +
		                        " <td class='col-md-8' colspan=9 style='font-weight:bold;'>" + Opis + "</td> " + 
		                        " <td class='col-md-2 text-right'> " + KUtils.formatFloat(Razlika)  + " </td>" + 
		                    "</tr> ";
		                table.append(d);
		                
	                //}
	            return table;
        }
        
   function ispisRuZahtjevSaldo(data) {
	            var table = $("<table class='k-grid' border=0 style='margin: 0px;' width='100%';>");

                table.append(
                    "<tr style='font-weight:bold;'>" + 
                        " <td class='col-md-2 text-right'> Iznos računa </td> " +                                       
                        " <td class='col-md-2 text-right'> Traženi iznos </td> " +                                       
                        " <td class='col-md-2 text-right'> Prihvatljivo </td> " +                                       
                        " <td class='col-md-2 text-right'> Iznos </td>" +
                        " <td class='col-md-2 text-right'> Izuzeto </td>" +
                        " <td class='col-md-2 text-right'> Neprihvatljivo </td>" +
                    "</tr>");
                var d = " <tr>" +
                        " <td class='col-md-2 text-right'> " + KUtils.formatFloat(data.FIznosRacuna) + " </td> " +                                       
                        " <td class='col-md-2 text-right'> " + KUtils.formatFloat(data.FTrazeniIznos) + " </td> " +                                       
                        " <td class='col-md-2 text-right' style='background-color:#f1f7eb;'> " + KUtils.formatFloat(data.FPrihvatljivoIznos) + " </td> " +                                       
                        " <td class='col-md-2 text-right' style='background-color:#f1f7eb;'> " + KUtils.formatFloat(data.FIznos) + " </td>" +
                        " <td class='col-md-2 text-right' style='background-color:#f9eded;'> " + KUtils.formatFloat(data.FIzuzetoUNeprihvatljivom) + " </td>" +
                        " <td class='col-md-2 text-right' style='background-color:#f9eded;'> " + KUtils.formatFloat(data.FTrazeniIznos - data.FPrihvatljivoIznos - data.FIzuzetoUNeprihvatljivom) + " </td>" +
                    "</tr> ";
                table.append(d);
	            return table;
        }
               
	function ispisRUgovorSaldoPo(data, round) {
				var SaldoPrih = data.FPrihvatljivoIznos - data.FZnsPrihvatljivoIznos;
				var Saldo = data.FIznos - data.FZnsIznos;
	            var table = $("<table class='k-grid' border=0 style='margin: 0px;' width='100%';>");
	            var lsStavka = '';
	            var lsUdio = '';

                	var lsTitle = "Na ukupan prihvatljiv iznos primijenjuje se udio. Razlika = Izračunati iznos - suma iznosa";
                	var Izracunato = KUtils.formatFloat(KUtils.parseFloat(data.FPrihvatljivoIznos*data.FUdioPosto/100 ), 2);
					var Razlika = KUtils.parseFloat(Izracunato) - KUtils.parseFloat(data.FIznos);
					if (!Razlika) Razlika = 0;
					
					if (KUtils.formatFloat(Razlika) == '0,00') {
						var lsClass = "";
						}	
					else {
						var lsClass = "class='alert-danger'";
						}	
					var Opis = "Kategorija (ug.): | " + 
						KUtils.formatFloat(data.FPrihvatljivoIznos) + ' | ' + KUtils.formatFloat(data.FIznos) +
						' | ' + KUtils.formatFloat(data.FPrihvatljivoIznos) + ' * ' + KUtils.formatFloat(data.FUdioPosto,round) + ' = ' +
						KUtils.formatFloat((data.FPrihvatljivoIznos*data.FUdioPosto)/100 ) +
						' | RAZLIKA -> ';
	                var d = " <tr " + lsClass +" title='" + lsTitle + "'>" +
	                        " <td class='col-md-8' colspan=9 style='font-weight:bold;'>" + Opis + "</td> " + 
	                        " <td class='col-md-2 text-right'> " + KUtils.formatFloat(Razlika)  + " </td>" + 
	                    "</tr> ";
	                table.append(d);
	            return table;
        }
        
        function rowAddPNabaveS(sifarnik, grid, data, rowEl){
			if (Number(data.VERZIJASTAVKE) !== data.VERZIJAMAX){
				sifarnik.applayRowCSS("COLOR=#FF0000;", rowEl);
			}
			
			if (Number(data.PNABAVES) == data.PNABAVESMIN){
				KUtils.ObojiCell(grid, rowEl, ['IZNOSUK','IZNOSSAPDVUK'], '#d8f2e6', "background-color");						
            }
            else {
                KUtils.ObojiCell(grid, rowEl,['PNABAVE','STAVKA','VERZIJASTAVKE','DATUM','EVBROJ','PREDMETNABAVE','CPV','CPVK','RUGRUPA2','RUGRUPA2NAZIV','REZIMNABAVE','REZIMNABAVEN','IMAGRUPE','IMAGRUPEN',
                'TIP','TIPNAZIV','NAPOMENA','NAZIV', 'DATUMIZVRSENJAOD', 'DATUMIZVRSENJADO'], 'silver', "color");    

				//ObojiCell(this, rowEl, ['IZNOSUK','IZNOSSAPDVUK'], '#FDFDDC', "background-color");						
                KUtils.IsprazniCelije(grid, rowEl,['IZNOSUK', 'IZNOSSAPDVUK']);    
            }
			KUtils.ObojiCell(grid, rowEl, ['IZNOS','IZNOSSAPDV'], '#EBFDDC', "background-color");		

			KUtils.ObojiCell(grid, rowEl, ['RASPOLOZIVO','RASPOLOZIVONETO'], '#f4f5b4', "background-color");		
			KUtils.ObojiCell(grid, rowEl, ['UGOVORENO','UGOVORENONETO'], '#cbe9f5', "background-color");		
			KUtils.ObojiCell(grid, rowEl, ['REZERVIRANO','REZERVIRANONETO'], '#e5f2f7', "background-color");		
			KUtils.ObojiCell(grid, rowEl, ['FAKTURIRANO','FAKTURIRANONETO'], '#e2fbdf', "background-color");		
			KUtils.ObojiCell(grid, rowEl, ['OTPUSTENO','OTPUSTENONETO'], '#dee4e6', "background-color");		
        }
                
        function rowAddPNabaveSDetaljni(sifarnik, grid, data, rowEl){
			//KUtils.ObojiCell(grid, rowEl, ['IZNOS','IZNOSSAPDV'], '#EBFDDC', "background-color");		

			KUtils.ObojiCell(grid, rowEl, ['RASPOLOZIVO','RASPOLOZIVONETO'], '#f4f5b4', "background-color");		
			KUtils.ObojiCell(grid, rowEl, ['UGOVORENO','UGOVORENONETO'], '#cbe9f5', "background-color");		
			KUtils.ObojiCell(grid, rowEl, ['REZERVIRANO','REZERVIRANONETO'], '#e5f2f7', "background-color");		
			KUtils.ObojiCell(grid, rowEl, ['FAKTURIRANO','FAKTURIRANONETO'], '#e2fbdf', "background-color");		
			KUtils.ObojiCell(grid, rowEl, ['OTPUSTENO','OTPUSTENONETO'], '#dee4e6', "background-color");		
        }

        function rowAddRiznica(sifarnik, grid, data, rowEl){
			if (!data.RSAKTIVNI){
                rowEl.css("color", "gray");
                rowEl.css("text-decoration", "line-through");
				
			}
        }

        function rowAddProtu(sifarnik, grid, data, rowEl, liKtoZn, lsPolja){
        	//lsPolja 'Pp' //P-IznosSaPdv, p-IznosBezPdv 
        	if ((data.SKBROJPROTUSTAVKE) && (data.SKBROJPROTUSTAVKE == 1)) {
				var column = grid.getCell(rowEl, 'SKBROJPROTUSTAVKE');
		        if (column) {
	        		column.html("SK");
		        }        		
        	} 

			var lfGkIzn = KUtils.formatFloat(data.DUGUJE - data.POTRAZUJE);	
			var lfIznSaPdv = KUtils.formatFloat(data.IZNOSSAPDV);	
			var lfIznBezPdv = KUtils.formatFloat(data.IZNOSBEZPDV);	
			var laOboji = [], k = 0; 			
			if (data.KNJIGARU) {
				if (data.RSGODINA && (data.RSGODINA != data.GODINATROSENJA)) {
					laOboji[k++] = 'RSGODINA';
				}	
				if (data.RSKONTO && (liKtoZn != 0) && (data.KONTO.substring(0, liKtoZn) != data.RSKONTO)) {
					laOboji[k++] = 'RSKONTO';
				}	
				if (data.RSPOZICIJA && (data.POZICIJA != data.RSPOZICIJA)) {
					laOboji[k++] = 'RSPOZICIJA';
				}	
				if (data.RSIZVORI && (data.IZVORI != data.RSIZVORI)) {
					laOboji[k++] = 'RSIZVORI';
				}	
				if (data.IZNOSSAPDV && (data.IZNOSSAPDV == 0)) {
					laOboji[k++] = 'IZNOSSAPDV';
				}	
				else if (data.IZNOSSAPDV && KUtils.imaOpciju(lsPolja, 'P', false) && (lfGkIzn != lfIznSaPdv)) {
					laOboji[k++] = 'IZNOSSAPDV';
				}	
				if (data.IZNOSBEZPDV && (data.IZNOSBEZPDV == 0)) {
					laOboji[k++] = 'IZNOSBEZPDV';
				}	
				else if (data.IZNOSBEZPDV && KUtils.imaOpciju(lsPolja, 'p', false) && (lfGkIzn != lfIznBezPdv)) {
					laOboji[k++] = 'IZNOSBEZPDV';
				}	
				if (data.KRSGODAKTIZVKTO && (data.KRSGODAKTIZVKTO != data.KGODAKTIZVKTO)) {
					laOboji[k++] = 'KRSGODAKTIZVKTO';
				}	
				KUtils.ObojiCell(grid, rowEl, laOboji, '#f3cdd8', "background-color");
			}
        }

        function KreirajPregledUgovorenoZaPNabaveS(data, ind, lbAkt, lbIzv, lbRiz, valuta){
            var table = $("<table class='table'>");
                if ((ind == 0) || (ind == 1)) {
                    var z = "<thead><tr class='info'>" + 
                            "<th>Grupa nabave</th> " +
                            "<th>RU broj</th> ";
                    if (lbRiz) z = z + "<th>KR</th>";
                    z = z + "<th title='Godina izvršenja'>Godina</th> " +
                            "<th class='text-right'>Ugovoreno (bez PDV-a) " + valuta + "</th>" + 
                            "<th class='text-right'>Ugovoreno " + valuta + "</th>" + 
                        "</tr></thead>";
                }
                else {
                	var z = "<thead><tr class='info'>" + 
                            "<th>Grupa nabave</th> " + 
                            "<th>RU broj</th> ";
                    if (lbRiz) z = z + "<th>KR</th>";
                    z = z + "<th title='Godina izvršenja'>Godina</th> ";
                    if (lbAkt) z = z + "<th>Aktivnost</th>";
                    if (lbIzv) z = z + "<th>Izvori</th>";
                    z = z + "<th>Konto</th>" +
                            "<th class='text-right'>Ugovoreno (bez PDV-a)</th>" + 
                            "<th class='text-right'>Ugovoreno</th>" +
                        "</tr></thead>"; 
	            }
                table.append(z);
            
			var lfUkNeto = 0;
			var lfUk = 0;
			var lsUgovoreno = '';
            for (var i = 0; i < data.length; ++i) {
                lfUk = lfUk + data[i].UGOVORENO;
                lfUkNeto = lfUkNeto + data[i].UGOVORENONETO;
                if ((ind == 0) || (ind == 1)) {
                    var d = "<tr>" +
                        "<td><small>" + data[i].IMAGRUPENAZIV + "</small></td>" +
                        "<td><small>" + data[i].RUGOVORNAZIV + "</small></td>";
					if (lbRiz) d = d + "<td><small>" + data[i].ZADNJIKR + "</small></td>";
                    d = d + "<td><small>" + data[i].GODINA + "</small></td>" +
                        "<td class='text-right'><small>" + KUtils.formatFloat(data[i].UGOVORENONETO)  + "</small></td>" + 
                        "<td class='text-right'><small>" + KUtils.formatFloat(data[i].UGOVORENO)  + "</small></td>" + 
                        "</tr>";
	                var liColSpan = 3;
	                if (lbRiz) liColSpan = liColSpan + 1;
                    }
                else {
                	var lsPozicija = data[i].POZICIJA ? data[i].POZICIJA : "";
                	var lsIzvori = data[i].IZVORI ? data[i].IZVORI : "";
                	var lsKonto = data[i].KONTO ? data[i].KONTO : "";
                    var d = "<tr'>" +
                            "<td><small>" + data[i].IMAGRUPENAZIV + "</small></td> " +
                            "<td><small>" + data[i].RUGOVORNAZIV + "</small></td> ";
					if (lbRiz) d = d + "<td><small>" + data[i].ZADNJIKR + "</small></td>";
                   	d = d + "<td><small>" + data[i].GODINA + "</small></td> ";
					if (lbAkt) d = d + "<td><small>" + lsPozicija + "</small></td>";
                    if (lbIzv) d = d + "<td><small>" + lsIzvori + "</small></td>";
                    d = d + "<td><small>" + lsKonto + "</small></td>" +
                            "<td class='text-right'><small>" + KUtils.formatFloat(data[i].UGOVORENONETO)  + "</small></td>" + 
                            "<td class='text-right'><small>" + KUtils.formatFloat(data[i].UGOVORENO)  + "</small></td>" + 
                        "</tr> ";
	                var liColSpan = 4;
	                if (lbRiz) liColSpan = liColSpan + 1;
	                if (lbAkt) liColSpan = liColSpan + 1;
	                if (lbIzv) liColSpan = liColSpan + 1;
                }
                table.append(d);
                if (i == data.length-1) {
                    if ((ind == 0) || (ind == 1)) {
                    	var lsColSpan = "colspan='" + liColSpan + "'"; //3
                        }
                    else {
                    	var lsColSpan = "colspan='" + liColSpan + "'";//6
                    } 
                    var d = "<tr class='info' style='font-weight:bold;'>"+
                        "<td " + lsColSpan + "> UKUPNO (" + valuta + ")</td> " +
                        "<td class='text-right'> " + KUtils.formatFloat(lfUkNeto) + " </td>" +
                        "<td class='text-right'> " + KUtils.formatFloat(lfUk) + " </td>" +
                        "</tr>";
                    table.append(d);
                }
                
            }
            lsUgovoreno = table;
            return lsUgovoreno;
        }

   function ispisSaldoDok(dokum, brojDokumenta, ind, backColor) {
        var templateSK = kendo.template(
		  "<div class='row'>" +
		    "<div class='col-sm-4'>Saldo SK <STRONG>" + dokum + ' ' + brojDokumenta + "</STRONG></div>"+
		    "<div class='col-sm-3 float-value'>#= FSDuguje #</div>"+
		    "<div class='col-sm-3 float-value'>#= FSPotrazuje #</div>"+
		  "</div>" +
		  "<div class='row'>" +
		    "<div class='col-sm-4'> &nbsp; </div>"+
		    "<div class='col-sm-3 float-value'> &nbsp; </div>"+
		    "<div class='col-sm-3 float-value'> &nbsp; </div>"+
		  "</div>"
		  );
            
        var templateGK = kendo.template(
		  "<div class='row'>" +
		    "<div class='col-md-4'>Saldo <STRONG>" + dokum + ' ' + brojDokumenta + "</STRONG></div>"+
		    "<div class='col-md-3 float-value' style='#=dugujeBoja #'>#= FSDuguje #</div>"+
		    "<div class='col-md-3 float-value' style='#=potrazujeBoja #'>#= FSPotrazuje #</div>"+
		  "</div>"+
		  "<div class='row'>" +
		    "<div class='col-md-4'>Promet <STRONG>" + dokum + ' ' + brojDokumenta + "</STRONG></div>"+
		    "<div class='col-md-3 float-value' style='#=dugujeBoja #'>#= FDuguje #</div>"+
		    "<div class='col-md-3 float-value' style='#=potrazujeBoja #'>#= FPotrazuje #</div>"+
		  "</div>"
		  );

        var table = $("<table class='table' style='background-color: " + backColor + "; border-top: 1px solid black; border-color: silver;' >");
		var gotovoDef = $.Deferred();		
		if (ind.indexOf('s') > -1) {
	        konto.gs.api.SaldoDokumenta(dokum, brojDokumenta)
	            .then(function (dataSK) {
	                if (dataSK) {
	                    dataSK.FSDuguje = KUtils.formatFloat(dataSK.FSDuguje, 2);
	                    dataSK.FSPotrazuje = KUtils.formatFloat(dataSK.FSPotrazuje, 2);
			            var rowSK = templateSK(dataSK);
				        table.append(rowSK);
						gotovoDef.resolve();
				        
	                }
	        });
	       }
	  	else {
			gotovoDef.resolve();
	  	}
        
		if (ind.indexOf('g') > -1) {
			gotovoDef.then(function(){
			    konto.gs.api.SaldoDokumentaKnjiga(dokum, brojDokumenta)
			        .then(function (dataGK) {
			            if (dataGK) {
			                if (dataGK.FSDuguje > dataGK.FSPotrazuje) {
			                	dataGK.dugujeBoja = "color: red;";
			                	dataGK.potrazujeBoja = "";
			                }
			                else if (dataGK.FSPotrazuje > dataGK.FSDuguje) {
			                	dataGK.potrazujeBoja = "color: red;";
			                	dataGK.dugujeBoja = "";
			                }
				            else {
			                	dataGK.potrazujeBoja = "";
			                	dataGK.dugujeBoja = "";
				            }
			            	
			                dataGK.FSDuguje = KUtils.formatFloat(dataGK.FSDuguje, 2);
			                dataGK.FSPotrazuje = KUtils.formatFloat(dataGK.FSPotrazuje, 2);
			
			                dataGK.FDuguje = KUtils.formatFloat(dataGK.FDuguje, 2);
			                dataGK.FPotrazuje = KUtils.formatFloat(dataGK.FPotrazuje, 2);
			                
			            	var rowGK = templateGK(dataGK);
					        table.append(rowGK);
			            }
			    });
			});	
        }
        
        return table;
        }
        
   function izrSaldoKnjigaPregled(dokum, brojDokumenta, backColor) {
        var cont = $("<div class='row'>");
        var salCont = $("<div class='col-md-4'>");
        
        var salContVal = $("<div class='col-md-4' style='padding: 0px;'>");
        //var table = $("<table class='table' style='background-color: " + backColor + "; border-top: 1px solid black; border-color: silver;' >");
        var tableVal = $("<table class='table' style='background-color: " + backColor + "; border-top: 1px solid black; border-color: silver;' >");
        
        var templateGK = kendo.template(
          "<div class='col-md-6'>" +
              "<div class='row' style='background-color: #=backColor # '>" + 
                "<div class='col-md-2'>Saldo</div>"+
                "<div class='col-md-2'><STRONG>" + dokum + "</STRONG></div>"+
                "<div class='col-md-2'><STRONG>" + brojDokumenta + "</STRONG></div>"+ 
                "<div class='col-md-3 float-value' style='color: #=DugujeFontColor #'>#= PSDugujeCaption #</div>"+
                "<div class='col-md-3 float-value' style='color: #=PotrazujeFontColor #'>#= PSPotrazujeCaption #</div>"+
              "</div>"+
              "<div class='row' style='background-color: #=backColor # '>" +
                "<div class='col-md-2'>Promet</div>"+
                "<div class='col-md-2'><STRONG>" + dokum + "</STRONG></div>"+
                "<div class='col-md-2'><STRONG>" + brojDokumenta + "</STRONG></div>"+
                "<div class='col-md-3 float-value' style='color: #=DugujeFontColor #'>#= PPDugujeCaption #</div>"+
                "<div class='col-md-3 float-value' style='color: #=PotrazujeFontColor #'>#= PPPotrazujeCaption #</div>"+
              "</div>" +
          "</div>" + 
              
          "<div class='col-md-6  #= prikaziValute # ' style='border-left: 1px solid; border-color: silver;' >" +
              "<div class='row' style='background-color: #=backColor # '>" + 
                "<div class='col-md-2'>Saldo</div>"+
                "<div class='col-md-1'><STRONG>" + dokum + "</STRONG></div>"+
                "<div class='col-md-2'><STRONG>" + brojDokumenta + "</STRONG></div>"+ 
                "<div class='col-md-1'><STRONG> #= ValutaCaption #</STRONG></div>" +
                "<div class='col-md-3 float-value' style='color: #=DugujeValFontColor #'>#= PSDugujeValCaption #</div>"+
                "<div class='col-md-3 float-value' style='color: #=PotrazujeValFontColor #'>#= PSPotrazujeValCaption #</div>"+
              "</div>"+
              "<div class='row' style='background-color: #=backColor # '>" +
                "<div class='col-md-2'>Promet</div>"+
                "<div class='col-md-1'><STRONG>" + dokum + "</STRONG></div>" + 
                "<div class='col-md-2'><STRONG>" + brojDokumenta + "</STRONG></div>" +
                "<div class='col-md-1'><STRONG> #= ValutaCaption #</STRONG></div>" +
                "<div class='col-md-3 float-value' style='color: #=DugujeValFontColor #'>#= PPDugujeValCaption #</div>" +
                "<div class='col-md-3 float-value' style='color: #=PotrazujeValFontColor #'>#= PPPotrazujeValCaption #</div>" +
              "</div>" +
         "</div>" +
         
         "<div class='col-md-12'>" +  
            "<div class='row saldoDNRow' >" +
                "<div class='col-md-2' title='Saldo dnevnika' style='cursor: pointer'><i onClick='saldoDNClick()'>Saldo dn.</i></div>" +
                "<div class='col-md-2 float-value saldoDNVis'><span class='pdDuguje'><span></div>"+ 
                "<div class='col-md-2 float-value saldoDNVis'><span class='pdPotrazuje'><span></div>"+ 
                "<div class='col-md-1 saldoDNCap' title='Saldo dnevnika u valuti'><span class='dnValCaption'><span></div>"+ 
                "<div class='col-md-1' ><span class='dnValuta'><span></div>"+
                "<div class='col-md-2 float-value '><span class='dnVal pdDugujeVal'><span></div>"+ 
                "<div class='col-md-2 float-value '><span class='dnVal pdPotrazujeVal'><span></div>"+ 
            "</div>"  +
         "</div>" 
         
        );
        
        
        konto.gs.api.KnjigaIzrSaldo(dokum, brojDokumenta)
            .then(function (dataGK) {
                if (dataGK){
                    if (dataGK.bPrikaziValute){
                        dataGK.prikaziValute = '';   
                    }else{
                        dataGK.prikaziValute = 'hide';
                    }  
                    dataGK.backColor = backColor;                   
                    var rowGK = templateGK(dataGK);
                    cont.append(rowGK);
                }
        });

        return cont;
   }

   function ispisKnjigaRuDok(obj, ind, backColor) {   	
        var templateSK = kendo.template(
		  "<div class='row' style='margin:0px; padding:1px;'>" +
		    "<div class='col-md-3'><strong>#=FSaldaTekst#</strong></div>"+
		    "<div class='col-md-2 text-right'>#=FGKSalda#</div>"+
		    "<div class='col-md-2 text-right' style='background-color: palegreen'>#=FKnjRuSalda#</div>"+
		    "<div class='col-md-2'><strong>Razlika</strong></div>"+		    
		    "<div class='col-md-2 text-right' title='#=FRazlikaSaldaHint#' style='color: #=FRazlikaSaldaBoja#'>#=FRazlikaSalda#</div>"+
		  "</div>"+		    
		  "<div class='row' style='margin:0px; padding:1px;'>" +
		    "<div class='col-md-3'><strong>#=FKnjigaTekst#</strong></div>"+
		    "<div class='col-md-2 text-right'>#=FGKKnjiga#</div>"+
		    "<div class='col-md-2 text-right' style='background-color: palegreen'>#=FKnjRuKnjiga#</div>"+
		    "<div class='col-md-2'><strong>Razlika</strong></div>"+		    
			"<div class='col-md-2 text-right' title='#=FRazlikaKnjigaHint#' style='color: #=FRazlikaKnjigaBoja#'>#=FRazlikaKnjiga#</div>"+		    
		  "</div>"		  
		);

        var templateRU = kendo.template(
		  "<div class='row' style='margin:0px; padding:1px;'>" +
		    "<div class='col-sm-2'><strong>#=FRuTekst#</strong></div>"+
		    "<div class='col-sm-2 text-right' title='#=FIznosRuHint#'>#=FIznosRu#</div>"+
		    "<div class='col-sm-2 text-right' title='#=FIzvrsenjeRuHint#' style='background-color: palegreen'>#=FIzvrsenjeRu#</div>"+
		    "<div class='col-sm-2 text-right' title='#=FOtpustenoRuHint#'>#=FOtpustenoRu#</div>"+		    
		    "<div class='col-sm-2'><strong>Saldo ug.</strong></div>"+
		   	"<div class='col-md-2 text-right' title='#=FSaldoRuHint#' style='background-color: deepskyblue; color: #=FSaldoRuBoja#'>#=FSaldoRu#</div>"+
		  "</div>"+		    
		  "<div class='row' style='margin:0px; padding:1px;'>" +
		    "<div class='col-sm-2'><strong>#=FRuSTekst#</strong></div>"+
		    "<div class='col-sm-2 text-right' title='#=FIznosRuSHint#'>#=FIznosRuS#</div>"+
		    "<div class='col-sm-2 text-right' title='#=FIzvrsenjeRuSHint#' style='background-color: palegreen'>#=FIzvrsenjeRuS#</div>"+
		    "<div class='col-sm-2 text-right' title='#=FOtpustenoRuSHint#'>#=FOtpustenoRuS#</div>"+		    
		    "<div class='col-sm-2'><strong>Saldo st.ug.</strong></div>"+
		   	"<div class='col-md-2 text-right' title='#=FSaldoRuSHint#' style='background-color: deepskyblue; color: #=FSaldoRuSBoja#'>#=FSaldoRuS#</div>"+
		  "</div>"		  
		);

        var table = $("<table class='table' style='background-color: " + backColor + "; border: 0px;' >");		
		if (ind.indexOf('s') > -1) {
	        obj.FGKSalda = KUtils.formatFloat(obj.FGKSalda, 2);
	        obj.FKnjRuSalda = KUtils.formatFloat(obj.FKnjRuSalda, 2);
	        obj.FRazlikaSalda = KUtils.formatFloat(obj.FRazlikaSalda, 2);	        
	        obj.FGKKnjiga = KUtils.formatFloat(obj.FGKKnjiga, 2);
	        obj.FKnjRuKnjiga = KUtils.formatFloat(obj.FKnjRuKnjiga, 2);
	        obj.FRazlikaKnjiga = KUtils.formatFloat(obj.FRazlikaKnjiga, 2);	        
	
	        var rowSK = templateSK(obj);
	        table.append(rowSK);
	  	}

		if (ind.indexOf('g') > -1) {
	        obj.FIznosRu = KUtils.formatFloat(obj.FIznosRu, 2);
	        obj.FIzvrsenjeRu = KUtils.formatFloat(obj.FIzvrsenjeRu, 2);
	        obj.FOtpustenoRu = KUtils.formatFloat(obj.FOtpustenoRu, 2);
	        obj.FSaldoRu = KUtils.formatFloat(obj.FSaldoRu, 2);
	        obj.FIznosRuS = KUtils.formatFloat(obj.FIznosRuS, 2);
	        obj.FIzvrsenjeRuS = KUtils.formatFloat(obj.FIzvrsenjeRuS, 2);
	        obj.FOtpustenoRuS = KUtils.formatFloat(obj.FOtpustenoRuS, 2);
	       	obj.FSaldoRuS = KUtils.formatFloat(obj.FSaldoRuS, 2);

            var rowRU = templateRU(obj);
	        table.append(rowRU);
        }                
        return table;
    }

	function SaldoMTroskaKartica(lsMt, data, backColor) {
        var templateKartica = kendo.template(
		  "<div class='row' style='padding:5px;'>" +
		    "<div class='col-md-4'>Projekt <STRONG>" + lsMt + "</STRONG></div>"+
		    "<div class='col-md-2'>Promet:</div>"+
		    "<div class='col-md-3 float-value'><STRONG>#= Potrazuje #</STRONG></div>"+
		    "<div class='col-md-3 float-value'><STRONG>#= Duguje #</STRONG></div>"+
		  "</div>"+
		  "<div class='row' style='margin:3px;'>" +
		    "<div class='col-md-4'></div>"+
		    "<div class='col-md-2' title='#= SaldoLabel #'>Saldo*:</div>"+
		    "<div class='col-md-3 float-value'><STRONG>#= Saldo #</STRONG></div>"+
		    "<div class='col-md-3 float-value'></div>"+
		  "</div>"
		  );
		
        var table = $("<table class='table' style='background-color: " + backColor + "' >");
        if (data) {
            var row = templateKartica(data);
	        table.append(row);
        }

        return table;
        }        
        
	function dajPredlozenoIzInfo (lsZaPodatak, lsPredlozenoIz, lblLabela) {
        lblLabela.css("color", "#06a6cb");
        lblLabela.css("font-weight", "bold");
		lblLabela.html('');			
		lblLabela.addClass("hide");
        lblLabela.title = "Označava odakle je podatak predložen (iz potpisivanja, iz registra ugovora, iz konto riznice, ..";

		if (KUtils.imaOpciju(lsPredlozenoIz, 'p' + lsZaPodatak, false)) {
			lblLabela.html('DOK');			
   			lblLabela.removeClass("hide");
		}
		if (KUtils.imaOpciju(lsPredlozenoIz, 'u' + lsZaPodatak, false)){
			lblLabela.html('RU');			
   			lblLabela.removeClass("hide");
		}
		if (KUtils.imaOpciju(lsPredlozenoIz, 'r' + lsZaPodatak, false)) {
			lblLabela.html('KR');			
   			lblLabela.removeClass("hide");
		}
    } 
		
   function filterPanelKnjiziDokSakrij(pnlFilter, ind) {
   		pnlFilter.find('.elem').each(function(key, obj) {
			if ($(obj).hasClass(ind)) {
	   			$(obj).removeClass("hide");
			}
			else {
	   			$(obj).addClass("hide");
			}
		});
    }

   function filterPanelKnjiziDokBtnActive(pnlFilter) {
   		pnlFilter.find('.filterBtnsGS').each(function(key, obj) {
			var nazivPolja = 'hid' + $(obj).attr('name').substring(3, 50).trim();
			if ((nazivPolja == 'hidKontoSK') && pnlFilter.find("." + nazivPolja).val() != '') {
	   			$(obj).addClass("active");
			}
			else if (pnlFilter.find("." + nazivPolja).val() == 1) {
	   			$(obj).addClass("active");
			}
			else {
	   			$(obj).removeClass("active");
			}
		});
    }
    
    function filterPanelOdrediTablicu(chale){
		var tablica = '';
		if ( $(chale).hasClass('filterKnjiga') ){
			tablica = 'Knjiga';
		}else if ( $(chale).hasClass('filterSalda')){
			tablica = 'Salda';	
		}
		return tablica;	
	}

   function filterPanelKnjiziDok(sifarnik, ind) {
        Filter = {};

        /**
         * Osnovna/pocetna inicijalizacija
         */
        Filter.init = function (sifarnik) {
        }; 

        /**
         * Incijalizacija kendo elemenata
         */
        Filter.kendoInit = function (sifarnik) {       
        };

        /**
         * Incijalizacija ostalih evenata
         */
        Filter.eventsInit = function (sifarnik) {

			// **** editi

            $(".edOpis").on("blur", function(){
                sifarnik.filterPanel.filterDispatcher($(this));
            });               
            
			if (ind.indexOf('S') >= 0) {
	            $(".edBrojRacuna").on("blur", function(){
	                sifarnik.filterPanel.filterDispatcher($(this));
	            });
	           }
            
            $(".edBrojDokumentaOd").on("blur", function(){
                sifarnik.filterPanel.filterDispatcher($(this));
            });
            
            $(".edBrojDokumentaDo").on("blur", function(){
                sifarnik.filterPanel.filterDispatcher($(this));
            });            
            
            //dokum
            sifarnik.setDokum = function (data) {   
                if (data) {
                    this.val(data.DOKUM + ' - ' + data.NAZIV);
                }
				sifarnik.filterPanel.filterDispatcher($(this));      
            };
            sifarnik.onDokumOdabir = sifarnik.setDokum;
            sifarnik.onDokumExit = sifarnik.setDokum;
            sifarnik.onDokumClear = sifarnik.setDokum;     

            //partneri
			if (ind.indexOf('S') >= 0) {
		        sifarnik.setPartner = function (data) {                
		            if (data) {
		                this.val(data.PARTNER + ' - ' + data.NAZIV);
		            }
		            sifarnik.filterPanel.filterDispatcher($(this));
		        };
		        sifarnik.onPartnerOdabir = sifarnik.setPartner;
		        sifarnik.onPartnerExit = sifarnik.setPartner;
		        sifarnik.onPartnerClear = sifarnik.setPartner;
		       }

            //zosoba
			if (ind.indexOf('G') >= 0) {
		        sifarnik.setZOsoba = function (data) {                
		            if (data) {
		                this.val(data.ZOSOBA + ' - ' + data.NAZIV);
		            }
		            sifarnik.filterPanel.filterDispatcher($(this));
		        };
		        sifarnik.onZOsobaOdabir = sifarnik.setZOsoba;
		        sifarnik.onZOsobaExit = sifarnik.setZOsoba;
		        sifarnik.onZOsobaClear = sifarnik.setZOsoba;
		       }

            //organ
            sifarnik.setOrgan = function (data) {                
                if (data) {
                    this.val(data.ORGAN + ' - ' + data.NAZIV);
                }
                sifarnik.filterPanel.filterDispatcher($(this));
            };
            sifarnik.onOrganOdabir = sifarnik.setOrgan;
            sifarnik.onOrganExit = sifarnik.setOrgan;
            sifarnik.onOrganClear = sifarnik.setOrgan;

            //izvori
			if ((ind.indexOf('G') >= 0) || (ind.indexOf('K') >= 0)) {
	            sifarnik.setIzvori = function (data) {                
	                if (data) {
	                    this.val(data.IZVORI + ' - ' + data.NAZIV);
	                }
	                sifarnik.filterPanel.filterDispatcher($(this));
	            };
	            sifarnik.onIzvoriOdabir = sifarnik.setIzvori;
	            sifarnik.onIzvoriExit = sifarnik.setIzvori;
	            sifarnik.onIzvoriClear = sifarnik.setIzvori;
	           }


            //konto 
			if ((ind.indexOf('G') >= 0) || (ind.indexOf('K') >= 0)) {
	            sifarnik.setKonto = function (data) {                
	                if (data) {
	                    this.val(data.KONTO + ' - ' + data.NAZIV);
	                }
	                sifarnik.filterPanel.filterDispatcher($(this));
	            };
	            sifarnik.onKontoOdabir = sifarnik.setKonto;
	            sifarnik.onKontoExit = sifarnik.setKonto;
	            sifarnik.onKontoClear = sifarnik.setKonto;
	           }
            
			if (ind.indexOf('K') >= 0) {
	            sifarnik.setValuta = function (data) {                
	                if (data) {
	                    this.val(data.VALUTA + ' - ' + data.NAZIV);
	                }
	                sifarnik.filterPanel.filterDispatcher($(this));
	            };
	            sifarnik.onValutaOdabir = sifarnik.setValuta;
	            sifarnik.onValutaExit = sifarnik.setValuta;
	            sifarnik.onValutaClear = sifarnik.setValuta;
	           }

            //zosoba za MT
			if (ind.indexOf('P') >= 0) {
		        sifarnik.setZOsobaZaMT = function (data) {                
		            if (data) {
		                this.val(data.ZOSOBA + ' - ' + data.NAZIV);
		                // ako ima MTroska i to MT nije od tte ZOsobe onda MT treba obrisati
		                if ($(".edMTroska").sifVal() != '') {
					        konto.sf.api.MTroskaProsirenoById($(".edMTroska").sifVal())
					            .then(function (dataMT) {
					                if (dataMT.zosoba != data.ZOSOBA) {
					                	$(".edMTroska").sifVal(null);
					                }
					        });
					        }
		            }
		            sifarnik.filterPanel.filterDispatcher($(this));
		        };
		        sifarnik.onZOsobaZaMTOdabir = sifarnik.setZOsobaZaMT;
		        sifarnik.onZOsobaZaMTExit = sifarnik.setZOsobaZaMT;
		        sifarnik.onZOsobaZaMTClear = sifarnik.setZOsobaZaMT;
		       }

	            $(".edZOsobaZaMT").on("blur", function(){
	                // ako ima MTroska i to MT nije od tte ZOsobe onda MT treba obrisati
	                if ($(".edMTroska").sifVal() != '') {
				        konto.sf.api.MTroskaProsirenoById($(".edMTroska").sifVal())
				            .then(function (dataMT) {
				                if (dataMT.zosoba != data.ZOSOBA) {
				                	$(".edMTroska").sifVal(null);
				                }
				        });
				        }
	                sifarnik.filterPanel.filterDispatcher($(this));
	            });
            
            //mtroska
            sifarnik.setMTroska = function (data) { 
                if (data) {
                    this.val(data.MTROSKA + ' - ' + data.NAZIV);
                }
                sifarnik.filterPanel.filterDispatcher($(this));
            };
            sifarnik.onMTroskaOdabir = sifarnik.setMTroska;
            sifarnik.onMTroskaExit = sifarnik.setMTroska;
            sifarnik.onMTroskaClear = sifarnik.setMTroska;
            sifarnik.onMTroskaSifarnikLink = function () {
                var link = "mtroska/pregled"; 
                if ($(".edZOsobaZaMT").sifVal() != 0) {
                	link = KUtils.addParamToUrl(link, "ZOsoba", $(".edZOsobaZaMT").sifVal());
                }
				//if (ind.indexOf('P') >= 0) { // iz pregleda projekata
    	        //	link = KUtils.addParamToUrl(link, "premaOvlastenju", true);
    	        //}
                return link;            
            };   

            //aktivnost
			if ((ind.indexOf('G') >= 0) || (ind.indexOf('K') >= 0)) {
	            sifarnik.setPozicija = function (data) {                
	                if (data) {
	                    this.val(data.POZICIJA + ' - ' + data.NAZIV);
	                }
	                sifarnik.filterPanel.filterDispatcher($(this));
	            };
	            sifarnik.onPozicijaOdabir = sifarnik.setPozicija;
	            sifarnik.onPozicijaExit = sifarnik.setPozicija;
	            sifarnik.onPozicijaClear = sifarnik.setPozicija;
	           }

			// **** pomoćne tipke
           	$(".btnVrDokDel").click(function() {
                    $(".edDokum").val("");  
                    $(".edDokum").blur();
            });
          
            $(".btnBrojDel").click(function() {
                    $(".edBrojDokumentaOd").val(""); 
                    $(".edBrojDokumentaDo").val("");  
                    $(".edBrojDokumentaOd").blur();
                    $(".edBrojDokumentaDo").blur();
            });
            
            $(".btnTrenutniDokument").click(function() {                               
                var obj = sifarnik.kontoGrid.getSelectedData();
                var dokum = $(".edDokum").sifVal();
                if (dokum != obj.DOKUM){
                    //$(".edDokum").sifVal(null); //ako ovog nema onda ne napravi dobro kad se obrišu filteri pa opet uzme isti DOKUM 
                    $(".edDokum").val(obj.DOKUM);
                    $(".edDokum").blur();
                }

                var br1 = $(".edBrojDokumentaOd").sifVal();
                var br2 = $(".edBrojDokumentaDo").sifVal(); 
                if ((br1 != obj.BROJDOKUMENTA) || (br2 != obj.BROJDOKUMENTA)){
                    $(".edBrojDokumentaOd").val(obj.BROJDOKUMENTA);
                    $(".edBrojDokumentaOd").blur(); 
                    $(".edBrojDokumentaDo").val(obj.BROJDOKUMENTA);  
                    $(".edBrojDokumentaDo").blur();
                }  
            });

			if ((ind.indexOf('G') >= 0) ||(ind.indexOf('K') >= 0)) {
	            $(".btnTrenutniKonto").click(function() { 
	                var obj = sifarnik.kontoGrid.getSelectedData();
	                var kont = $(".edKonto").sifVal();
	                if (kont != obj.KONTO){                   
	                    $(".edKonto").val(obj.KONTO);
	                    $(".edKonto").blur();
	                }
	            });

	            $(".btnKontoDel").click(function() {                   
	                $(".edKonto").val("");
	                $(".edKonto").blur();             
	            });
	           }
            
            if (ind.indexOf('K') >= 0) {
				$(".cBSvaKontaId").click(function() { 
					var kontoOd = $(".edKontoOd").sifVal();
					
					if ($(this).isKontoChecked()){
						konto.gs.api.PredloziKontoDo(kontoOd)
							.then(function(kontoDO){
								$(".edKontoDo").sifVal(kontoDO);	
							});
					}
					
				});
			}
				
			if (ind.indexOf('K') >= 0) {
	            $(".btnTrenutnaValuta").click(function() { 
	                var obj = sifarnik.kontoGrid.getSelectedData();
	                var kont = $(".edValuta").sifVal();
	                if (kont != obj.VALUTA){                   
	                    $(".edValuta").val(obj.VALUTA);
	                    $(".edValuta").blur();
	                }
	            });

	            $(".btnValutaDel").click(function() {                   
	                $(".edValuta").val("");
	                $(".edValuta").blur();   
          
	            });
	           }

			if (ind.indexOf('S') >= 0) {
	            $(".btnTrenutniPartner").click(function() { 
	                var obj = sifarnik.kontoGrid.getSelectedData();
	                if(obj) {
	                    var part = $(".edPartner").sifVal();
	                    if (part != obj.PARTNER){                   
	                        $(".edPartner").val(obj.PARTNER);
	                        $(".edPartner").blur();
	                    }
	                    $(".edBrojDokumentaOd").val("");
	                    $(".edBrojDokumentaOd").blur(); 
	                    $(".edBrojDokumentaDo").val(""); 
	                    $(".edBrojDokumentaDo").blur();
	                    $(".edDokum").val("");
	                    $(".edDokum").blur();
	                };
	            });
	            
	            $(".btnPartnerDel").click(function() { 
	                    $(".edPartner").val("");
	                    $(".edPartner").blur();
	            });
	           }
            
            $(".btnPlus10").click(function(){
                var brDok = $(".edBrojDokumentaDo").sifVal();
                if (brDok == "") brDok = 0;
                brDok = parseInt(brDok) + 10;
                $(".edBrojDokumentaDo").val(brDok);
                $(".edBrojDokumentaDo").blur();
            });
            
            $(".btnMinus10").click(function(){
                var brDok = $(".edBrojDokumentaOd").sifVal();
                if (brDok == "") brDok = 0;
                brDok = parseInt(brDok) - 10;
                $(".edBrojDokumentaOd").val(brDok);
                $(".edBrojDokumentaOd").blur();
            });
            
            $(".btnPrviZadnji").click(function(){
                var obj = sifarnik.kontoGrid.getSelectedData();
                if (obj){
	                var tablica = utils.filterPanelOdrediTablicu(this);
	                konto.gs.api.GetBrojDokumenta(obj.DOKUM, "Z", tablica)
	                    .then(function (rezZ) {
	                        if (rezZ) {
	                            $(".edBrojDokumentaDo").val(rezZ);
	                            $(".edBrojDokumentaDo").blur();
	                        }               
	                });
	                
	                konto.gs.api.GetBrojDokumenta(obj.DOKUM, "P", tablica)
	                    .then(function (rezP) {
	                        if (rezP) {
	                            $(".edBrojDokumentaOd").val(rezP);
	                            $(".edBrojDokumentaOd").blur();
	                        }               
	                });
                }                
            });
                        
            $(".btnPrvi").click(function(){
				var obj = sifarnik.kontoGrid.getSelectedData();
				if (obj){
					var tablica = utils.filterPanelOdrediTablicu(this);
	                konto.gs.api.GetBrojDokumenta(obj.DOKUM, "P", tablica)
	                    .then(function (rezP) {
	                        if (rezP) {
	                            $(".edBrojDokumentaOd").val(rezP);
	                            $(".edBrojDokumentaOd").blur();
	                            $(".edBrojDokumentaDo").val(rezP);
	                            $(".edBrojDokumentaDo").blur();
	                        }               
	                });
                }
            });   
            
            $(".btnZadnji").click(function(){				
                var obj = sifarnik.kontoGrid.getSelectedData();
                if (obj){
	                var tablica = utils.filterPanelOdrediTablicu(this);
	                konto.gs.api.GetBrojDokumenta(obj.DOKUM, "Z", tablica)
	                    .then(function (rezZ) {
	                        if (rezZ) {
	                            $(".edBrojDokumentaOd").val(rezZ);
	                            $(".edBrojDokumentaOd").blur();
	                            $(".edBrojDokumentaDo").val(rezZ);
	                            $(".edBrojDokumentaDo").blur();
	                        }               
	                });
                }
            }); 

			if (ind.indexOf('S') >= 0) {
				
	            $(".hidSamoOtvoreneS").on("blur", function(){
	                sifarnik.filterPanel.filterDispatcher($(this));
	            });
	            
	            $(".hidSamoNeproknjizeneS").on("blur", function(){
	                sifarnik.filterPanel.filterDispatcher($(this));
	            });
	            
	            $(".hidOtvaraZatvara").on("blur", function(){
	                sifarnik.filterPanel.filterDispatcher($(this));
	            });
	            
                $(".hidKontoSK").on("blur", function(){
                    sifarnik.filterPanel.filterDispatcher($(this));
                });
				
			    $('.btnSamoOtvoreneS').click(function() {
			        var active;
			        if ($(this).hasClass('active')) {
			            $(this).removeClass('active');
			            active = -1;
			        } else {
			            $(this).addClass('active');
			            active = 1;
			        }
			        $(".hidSamoOtvoreneS").val(active);
			        $(".hidSamoOtvoreneS").blur();
			    }); 
				
		        $('.btnSamoNeproknjizeneS').click(function() {
		            var active;
		            if ($(this).hasClass('active')) {
		                $(this).removeClass('active');
		                active = -1;
		            } else {
		                $(this).addClass('active');
		                active = 1;
		            }
		            $(".hidSamoNeproknjizeneS").val(active);
		            $(".hidSamoNeproknjizeneS").blur();
		                        
		        });      
	
		        $('.btnOtvaraZatvara').click(function() {  
		            var active;
	                if ($(this).hasClass('active')) {
	                    $(this).removeClass('active');
	                    active = -1;
	                } else {
	                    $(this).addClass('active');
	                    active = 1;
	                };
		            $(".hidOtvaraZatvara").val(active);
		            $(".hidOtvaraZatvara").blur();              
		        });
	
	            $('.btnKontoSK').click(function() {  
	                var active;
                    if ($(this).hasClass('active')) {
                        $(this).removeClass('active');
                        active = '';
                    } else {
                        $(this).addClass('active');
                        active = $(".hidParamKontoSK").val(); //"{{$filterKontoSK}}";
                    };
	                $(".hidKontoSK").val(active);
	                $(".hidKontoSK").blur();              
	            });
	            
            $('.ukloniFiltereBtn').click(function() {
                $(".hidSamoOtvoreneS").val(-1);
                $(".hidSamoNeproknjizeneS").val(-1);
                $(".hidOtvaraZatvara").val(-1);
				//$(".hidKontoSK").val("{{$filterKontoSK}}");
				$(".hidKontoSK").val($(".hidParamKontoSK").val());
				$(".filterBtnsGS").removeClass('active');  
            });
	            
			}

        };

		return Filter;
        }        

function izrSaldoKnjigaFilter(filKonto, filKontoOd, filKontoDo, filValuta, filPozicija, filIzvori, Verzija, backColor) {
        var cont = $("<div class='row'>");
        var salCont = $("<div class='col-md-4'>");
        
        var salContVal = $("<div class='col-md-4' style='padding: 0px;'>");
        //var table = $("<table class='table' style='background-color: " + backColor + "; border-top: 1px solid black; border-color: silver;' >");
        var tableVal = $("<table class='table' style='background-color: " + backColor + "; border-top: 1px solid black; border-color: silver;' >");
        
        var templateGK = kendo.template(
         
          "<div class='col-md-6'>" +
              "<div class='row' style='background-color: #=backColor # '>" + 
                "<div class='col-md-2'>Promet u valuti</div>"+
                "<div class='col-md-2 '>#= PSaldoDokValCaption #</div>"+
                "<div class='col-md-3 float-value' style='color: #=DugujeFontColor #'>D:  #= PSDugujeValCaption #</div>"+
                "<div class='col-md-3 float-value' style='color: #=PotrazujeFontColor #'>P:  #= PSPotrazujeValCaption #</div>"+
              "</div>"+
          "</div>"+  

          "<div class='col-md-6'>" +
              "<div class='row' style='background-color: #=backColor # '>" + 
                "<div class='col-md-2'>Promet u EUR</div>"+
                "<div class='col-md-3 float-value' style='color: #=DugujeFontColor #'>D:  #= PSDugujeCaption #</div>"+
                "<div class='col-md-3 float-value' style='color: #=PotrazujeFontColor #'>P:  #= PSPotrazujeCaption #</div>"+
              "</div>"+
          "</div>"  
          
         
        );
                
        konto.gs.api.KnjigaIzrSaldoFilter(filKonto, filKontoOd, filKontoDo, filValuta, filPozicija, filIzvori, Verzija)
            .then(function (dataGK) {
                if (dataGK){
                    if (dataGK.bPrikaziValute){
                        dataGK.prikaziValute = '';   
                    }else{
                        dataGK.prikaziValute = 'hide';
                    }  
                    dataGK.backColor = backColor;                   
                    var rowGK = templateGK(dataGK);
                    cont.append(rowGK);
                }
        
      	});

        return cont;
   }

} (konto.gs.utils = {}));